var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 512,
    height: 512,
    id: "fi_4096114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.54,30H20.32a3.46,3.46,0,0,1-3.46-3.46V20.32a3.46,3.46,0,0,1,3.46-3.46h6.23A3.46,3.46,0,0,1,30,20.32v6.23A3.46,3.46,0,0,1,26.54,30ZM20.32,18.86a1.46,1.46,0,0,0-1.46,1.46v6.23A1.46,1.46,0,0,0,20.32,28h6.23A1.46,1.46,0,0,0,28,26.54V20.32a1.46,1.46,0,0,0-1.46-1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.68,30H5.46A3.46,3.46,0,0,1,2,26.54V20.32a3.46,3.46,0,0,1,3.46-3.46h6.23a3.46,3.46,0,0,1,3.46,3.46v6.23A3.46,3.46,0,0,1,11.68,30ZM5.46,18.86A1.46,1.46,0,0,0,4,20.32v6.23A1.46,1.46,0,0,0,5.46,28h6.23a1.46,1.46,0,0,0,1.46-1.46V20.32a1.46,1.46,0,0,0-1.46-1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.54,15.14H20.32a3.46,3.46,0,0,1-3.46-3.46V5.46A3.46,3.46,0,0,1,20.32,2h6.23A3.46,3.46,0,0,1,30,5.46v6.23A3.46,3.46,0,0,1,26.54,15.14ZM20.32,4a1.46,1.46,0,0,0-1.46,1.46v6.23a1.46,1.46,0,0,0,1.46,1.46h6.23A1.46,1.46,0,0,0,28,11.68V5.46A1.46,1.46,0,0,0,26.54,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.68,15.14H5.46A3.46,3.46,0,0,1,2,11.68V5.46A3.46,3.46,0,0,1,5.46,2h6.23a3.46,3.46,0,0,1,3.46,3.46v6.23A3.46,3.46,0,0,1,11.68,15.14ZM5.46,4A1.46,1.46,0,0,0,4,5.46v6.23a1.46,1.46,0,0,0,1.46,1.46h6.23a1.46,1.46,0,0,0,1.46-1.46V5.46A1.46,1.46,0,0,0,11.68,4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOpen);
export default __webpack_public_path__ + "static/media/menu-open.ff7e39fc55fcaf65767fb5620683d31f.svg";
export { ForwardRef as ReactComponent };